import { Dialog } from '@headlessui/react';
import { Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import 'react-multi-carousel/lib/styles.css';
import '../style.css';
import { IconCloseSvg } from 'apps/sigma2-ui/src/components/svg/IconClose';

type ExplainerVideoModalProps = Omit<
  Parameters<typeof Dialog>[0],
  'onClose'
> & {
  videoUrl: string;
  title: string;
  onClose: () => void;
};

export const ExplainerVideoModal = ({
  open,
  onClose,
  videoUrl,
  title,
}: ExplainerVideoModalProps) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        as="div"
        style={{ minWidth: '61rem' }}
        className="fixed inset-0 z-overlay overflow-y-auto font-sans"
        onClose={onClose}
      >
        <div className="min-h-screen text-center px-6">
          <Transition.Child>
            <Dialog.Overlay className="fixed inset-0 bg-gray-1000 bg-opacity-50" />
          </Transition.Child>
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              data-qa="treatmentSelectionModal"
              id="treatmentSelectionModal"
              className="inline-flex my-4 overflow-hidden text-left h-full align-middle transition-all transform bg-white shadow-12px rounded-lg w-full max-w-6xl flex-col relative"
            >
              <Dialog.Title
                as="h3"
                data-qa="treatmentVideoHeading"
                style={{
                  backgroundImage:
                    'radial-gradient(112.91% 137.83% at 115.91% 137.83%, #0A56A2 0%, #012C57 72.37%, #012C57 100%)',
                }}
                className="relative font-sans leading-6 font-normal text-xl p-6 text-white flex justify-between items-center text-wrap"
              >
                {title}
                <button
                  data-testid="close-modal"
                  onClick={onClose}
                  className="inline-block p-1.5 hover:bg-blue-900 rounded-md bg-opacity-20 transition-colors"
                >
                  <IconCloseSvg svg={{ className: 'text-white w-4' }} />
                </button>
              </Dialog.Title>
              <div className="h-full ">
                <div className="h-full w-full p-4">
                  <iframe
                    title="YouTube Video Player"
                    src={videoUrl}
                    className="w-full h-96 md:h-96 lg:h-[32rem]"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
